import { questionTypes } from '../enums';

export const appCaregiverConfig = {
  title: 'App Users - Caregiver',
  questions: [
    {
      title:
        'Has the Pyx Health program given you companionship? If YES, what part of the program gave you companionship?',
      guids: ['78763a78-2854-4e0d-9182-39423629430d'],
      types: [questionTypes.CLOSED],
      options: ['YES', 'NO'],
      typeOptions: {
        [questionTypes.CLOSED]: {
          YES: [
            {
              title: 'If YES, what services did you use?',
              guids: ['0389d5f0-a94c-4396-b013-f1ff221ae55f'],
              types: [questionTypes.FREETEXT],
            },
          ],
        },
      },
    },
    {
      title:
        'On a scale of 1 to 5 (one being the least satisfied and five being the most), how satisfied are you with your experience on the Pyx Health program?',
      guids: ['5352b470-9f8e-4f7d-871b-d1e4911aace9'],
      types: [questionTypes.RATING],
      options: ['1', '2', '3', '4', '5'],
    },
    {
      title: 'Did the services provided by Pyx help you be a better caregiver/guardian?',
      guids: ['f0553a90-8179-4cd0-b77c-f7b65d57deeb'],
      types: [questionTypes.CLOSED],
      options: ['YES', 'NO'],
      typeOptions: {
        [questionTypes.CLOSED]: {
          YES: [
            {
              title: 'If so, what were the most valuable aspects of the program?',
              guids: ['60ae2e1c-7fd2-4d75-b687-8a2c11987cf7'],
              types: [questionTypes.FREETEXT],
            },
          ],
        },
      },
    },
    {
      title:
        'Would having additional benefits for yourself through the health plan that covers the person in your care (such as training and support programs) be an incentive for you to support continued enrollment in this health plan?',
      guids: ['ad25607c-5853-4888-9717-1bbe0592eed9'],
      types: [questionTypes.RATING],
      options: ['YES', 'NO'],
    },
    {
      title: 'As a caregiver/guardian - the most important resource I receive or need is...',
      guids: ['dd00e93f-a8f2-4011-8a46-2626825d553f'],
      types: [questionTypes.FREETEXT],
    },
    {
      title:
        'Is there anything that you would like me to know that you like, dislike, or have suggestions about regarding the app or the program?',
      guids: ['51d99ed4-dc9c-4cca-87e8-1a28fecda2c8'],
      types: [questionTypes.FREETEXT],
    },
    {
      title:
        'How likely is it that you would recommend Pyx to a friend or collegue? (Scale 1-10 [1 - Not likely to recommend, 10 - Extremely likely to recommend])',
      guids: ['dfad0e84-b21a-4ec2-a024-ddd67e3ec040'],
      types: [questionTypes.RATING],
      options: ['1', '2', '3', '4', '5', '6', '7', '8', '9', '10'],
    },
  ],
};
